import { Spinner } from './Spinner';

// Mirrors the static boot shell in index.html — same 64px spinner, same
// caption, same gray-100/gray-900 surfaces — so the React handoff is
// pixel-invisible instead of a shrinking spinner over a flashing background.
export const ScreenPreloader = () => (
  <div className="fixed inset-0 flex flex-col items-center justify-center gap-4 bg-gray-100 dark:bg-gray-900">
    <Spinner size={64} />
    <p className="paragraph-2 text-gray-700 dark:text-gray-300">Loading your video call&hellip;</p>
  </div>
);
